import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SetLoader, SetDirection, SetVersion } from '../store/actions';
import { AlertService } from './alerts.service';
import { AuthService } from './auth.service';
import { TranslationService } from './translation.service';
import { AlertType } from '../typings/alerts';
import { APP_ALERT_OUTPUT } from '../models/alert.const';
import { State } from '../typings/state';
import { LegalEntitiesService } from './legal-entities.service';
import { Direction } from '../cmx-layout/types/directions';

@Injectable({
  providedIn: 'root',
})
export class CmxClientService {
  constructor(
    private alerts: AlertService,
    private authService: AuthService,
    private translation: TranslationService,
    private entity: LegalEntitiesService,
    private store: Store<State>,
  ) {}

  init() {
    this.translation.preInit();
    this.translation.init();
  }

  addAlert(target: string, type: AlertType, text: string, click?: any): number {
    return this.alerts.addAlert(target, type, text, click);
  }

  closeAlert(target: string, id: number) {
    this.alerts.closeAlert(id, target);
  }

  addMainAlert(type: AlertType, text: string, click?: any): number {
    return this.alerts.addAlert(APP_ALERT_OUTPUT, type, text, click);
  }

  closeMainAlert(id: number) {
    this.alerts.closeAlert(id, APP_ALERT_OUTPUT);
  }

  closeAllAlerts() {
    this.alerts.closeAlerts();
  }

  showGlobalLoader() {
    this.store.dispatch(new SetLoader(true));
  }

  hideGlobalLoader() {
    this.store.dispatch(new SetLoader(false));
  }

  setDirection(direction: Direction) {
    this.store.dispatch(new SetDirection(direction));
  }

  setLegalEntity(legalEntityId: number) {
    this.entity.setActiveLegalEntity(legalEntityId);
  }

  logout() {
    this.authService.logout();
  }

  setVersion(version: number) {
    this.store.dispatch(new SetVersion(version));
  }
}
